import React, { useState } from 'react'
import { List, ListItem, ListItemText, Divider,Button,to} from "@material-ui/core";
import "../styles/MemberSideNav.css"
import { useSelector, useDispatch } from 'react-redux';
import { userActions } from '../actions/user.actions'
import { useHistory } from 'react-router-dom'
// import { TrafficOutlined } from '@mui/icons-material';

function ResMemsidenav() {

  const LoginReducer = useSelector(state => state.LoginReducer)
  const dispatch = useDispatch();
  const history = useHistory();
  const [hide,setHide]=useState(false)

  // useEffect(() => {
  //   if(!LoginReducer.loggedIn){
  //     history.push("/membership_login")
  //   }
  // }, [LoginReducer, history])

  function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
  }

  const handleLogOut = () => {
    dispatch(userActions.logout())
    setHide(true)
    history.push("/membership_login")
  }
  const result = JSON.parse(localStorage.getItem("result"))
  const handleView = async (value) => {
    history.push(`/member/mydetials/${value}`);
  }
const sidenav=JSON.parse(localStorage.getItem("nav"))

  return (
    <div style={{width:"70%",position:'fixed',
    left:'0',
    top:'60px',
    height: '100%',
    backgroundColor: '#4869B0',
    color: 'white',}}>
      {
        hide?
        <List component="nav" >
        <ListItemLink className="listNav" href="/member/deshboard" style={{textAlign:'center',marginTop:'10px',width:'250px',marginLeft:"10px",borderStyle:" solid",borderWidth:'2px'}} button>
          <ListItemText primary="Become a Member" />
        </ListItemLink>
        <ListItemLink className="listNav" onClick={() => handleView(result._id)}  style={{textAlign:'center',marginTop:'10px',width:'250px',marginLeft:"10px",borderWidth:'2px',borderStyle:" solid"}} button>
          <ListItemText primary="Member Login" />
        </ListItemLink>
      </List>:
      <List component="nav" >
          <ListItemLink className="listNav" href="/member/deshboard" style={{textAlign:'center',marginTop:'10px',width:'250px',marginLeft:"10px",borderStyle:" solid",borderWidth:'2px'}} button>
            <ListItemText primary="Home" />
          </ListItemLink>
          <ListItemLink className="listNav" onClick={() => handleView(result._id)}  style={{textAlign:'center',marginTop:'10px',width:'250px',marginLeft:"10px",borderWidth:'2px',borderStyle:" solid"}} button>
            <ListItemText primary="My Details" />
          </ListItemLink>
          <ListItemLink className="listNav" href="/member/NoticeMemberPage"  style={{textAlign:'center',marginTop:'10px',width:'250px',marginLeft:"10px",borderWidth:'2px',borderStyle:" solid"}} button>
            <ListItemText primary="Notices" />
          </ListItemLink>
          <ListItemLink className="listNav" href="/member/MemberKit"  style={{textAlign:'center',marginTop:'10px',width:'250px',marginLeft:"10px",borderWidth:'2px',borderStyle:" solid"}} button>
            <ListItemText primary="Member Kit" />
          </ListItemLink>
          <ListItemLink className="listNav" href="/member/member_resetPass"  style={{textAlign:'center',marginTop:'10px',width:'250px',marginLeft:"10px",borderWidth:'2px',borderStyle:" solid"}} button>
            <ListItemText primary="Reset Password" />
          </ListItemLink>
          <ListItem  style={{textAlign:'center',width:'250px',marginLeft:"10px",marginTop:'10px',borderStyle:" solid",borderWidth:'2px'}} button >
            <ListItemText primary="Log Out" onClick={handleLogOut} />
          </ListItem>
        </List>
      }
        
    </div>
  )
}

export default ResMemsidenav
